const SearchBad = () => {
    

    return (
        <p className="no_search_results">No Results Found</p>
    )
}

export default SearchBad;